import { isNil } from 'lodash';

export const hasChildren = (items: any[], subLocations?: any[] | null) => {
  return items.length > 0 || (!isNil(subLocations) && subLocations.length > 0);
};
